// Utilidades compartidas del flujo Amatea (precio, formateo COP, detección de marca de tarjeta, Luhn).
export const TREE_PRICE = 13000

export function fmtCOP (n) {
  return '$' + Math.round(n).toLocaleString('es-CO')
}

export function detectBrand (num) {
  const n = (num || '').replace(/\s/g, '')
  if (/^4/.test(n)) return 'visa'
  if (/^(5[1-5]|2[2-7])/.test(n)) return 'mc'
  if (/^3[47]/.test(n)) return 'amex'
  if (/^6(?:011|5)/.test(n)) return 'disc'
  return null
}

export function formatCardNumber (v) {
  const digits = (v || '').replace(/\D/g, '').slice(0, 19)
  return digits.replace(/(.{4})/g, '$1 ').trim()
}

export function luhnOk (num) {
  const s = (num || '').replace(/\D/g, '')
  if (s.length < 12) return false
  let sum = 0
  let alt = false
  for (let i = s.length - 1; i >= 0; i--) {
    let n = parseInt(s[i], 10)
    if (alt) { n *= 2; if (n > 9) n -= 9 }
    sum += n
    alt = !alt
  }
  return sum % 10 === 0
}
